import {Form} from '../../../../../stores/Form';
import React, {useCallback} from 'react';
import {shouldChangePage, changePaginationPage, NavDirection} from '../utils/navigation-helpers';

export const useMouseWheelNav = (form: Form) => {
    const wheelApiBlocker = React.useRef(false);

    return useCallback(
        async (e: WheelEvent) => {
            if (!form?.tableAPI || wheelApiBlocker.current) return;
            const delta = Math.round(e.deltaY);

            const direction = delta > 0 ? NavDirection.next : NavDirection.prev;
            const currentRow = form.currentRow;
            const currCellIndex = form.currentColumn.index;
            if (shouldChangePage(form, currentRow, direction)) {
                wheelApiBlocker.current = true;
                await changePaginationPage(form, direction);
                wheelApiBlocker.current = false;
            } else {
                let nextRowIndex = currentRow;
                const recordsCount = form.records.length;
                if (direction === NavDirection.next) {
                    nextRowIndex = currentRow < recordsCount - 1 ? currentRow + 1 : 0;
                } else {
                    nextRowIndex = currentRow > 0 ? currentRow - 1 : recordsCount - 1;
                }

                form.tableAPI.focusCell(currCellIndex, nextRowIndex);
            }
        },
        [form]
    );
};
